/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';

const LinkUnderlineAnimation = (props) => {

    const { children, href, id, large } = props;
    
    const { isMobile } = useResponsive();

    const linkClasses = ['link-underline'];

    if (isMobile) {
        linkClasses.push('link-underline--animated');
    }

    const largeLinkClasses = ['link-underline-large'];

    return (       
        <div href={href}>            
            {!large && (
                <a id={id} href={href} className={linkClasses.join(' ')}>
                    {children}
                </a>
            )}
            {large && (
                <a id={id} href={href} className={largeLinkClasses.join(' ')}>
                    {children}
                </a>
            )}
        </div>       
    );
};

LinkUnderlineAnimation.propTypes = {
    children: PropTypes.any,
};

export default LinkUnderlineAnimation;

LinkUnderlineAnimation.propTypes = {
    href: PropTypes.string,
    id: PropTypes.string,
    large: PropTypes.bool,
};

